import React, { useState, useEffect } from 'react'
import './userdashboardfundaccount.css'
import { useNavigate } from 'react-router-dom'
import { MdClose } from 'react-icons/md'
import { FiChevronRight, FiArrowDownLeft, FiClock } from 'react-icons/fi'
import Swal from 'sweetalert2'
import Userdashboardheader from '../userdashboardheader/Userdashboardheader'
import DashboardTopbar from '../dashboardShell/DashboardTopbar'
import PageHero from '../dashboardShell/PageHero'
import { fetchDashboardUser } from '../dashboardShell/userSession'
import Checkout from '../Checkout'

const depositOptions = [
  { id:1, image:'/btc.png',       method:'BTC',                min:1, wallet:'bc1qs7x2x43jlc6ln5klfw77aswkkm4sfzf5nqvqmc' },
  { id:2, image:'/etherium.png',  method:'ETH',                min:1, wallet:'0x9fc6aa8e4A31a736b4723D1506543FFD571489f6' },
  { id:3, image:'/trc.jpg',       method:'USDT (TRC-20)',       min:1, wallet:'TKYSH6vrdhrxJEh1DF5YWoRfk5m3UtbYZ4' },
  { id:4, image:'/solana.png',    method:'Solana (SOL)',        min:1, wallet:'6ToY2pwMAGETYQ7X7JqpxCR7GMp62FFmGYj7vF4Rs2CH' },
  { id:5, image:'/erc.jpg',       method:'USDT (ERC-20)',       min:1, wallet:'0x9fc6aa8e4A31a736b4723D1506543FFD571489f6' },
  { id:6, image:'/bep.png',       method:'USDT (BEP-20)',       min:1, wallet:'6ToY2pwMAGETYQ7X7JqpxCR7GMp62FFmGYj7vF4Rs2CH' },
  { id:7, image:'/xrp-icon.png',  method:'XRP',                min:1, wallet:'raCpLSA7F1cYPdrnyWBPRoxuosrbxvMEwY' },
  { id:8, image:'/usdc-coin.png', method:'USDC (Base Mainnet)', min:1, wallet:'0x9fc6aa8e4A31a736b4723D1506543FFD571489f6' },
]

const Toast = Swal.mixin({ toast:true, position:'top-end', showConfirmButton:false, timer:3000, timerProgressBar:true })

const Userdashboardfundaccount = ({ route }) => {
  const navigate = useNavigate()
  const [selectedCrypto, setSelectedCrypto] = useState(null)
  const [depositAmount, setDepositAmount] = useState('')
  const [showModal, setShowModal] = useState(false)
  const [activeMethod, setActiveMethod] = useState(null)
  const [checkoutPage, setCheckoutPage] = useState(false)
  const [balance, setBalance] = useState(0)

  useEffect(() => {
    fetchDashboardUser(route).then(user => setBalance(user?.funded || 0))
  }, [route])

  const handleNext = () => {
    const amt = parseInt(depositAmount)
    if (isNaN(amt)) return Toast.fire({ icon:'warning', title:'Enter a valid number' })
    if (amt < activeMethod.min) return Toast.fire({ icon:'warning', title:`Minimum deposit is $${activeMethod.min}` })
    setCheckoutPage(true)
  }

  if (checkoutPage) {
    return <Checkout Active={activeMethod} depositAmount={parseInt(depositAmount)} closepage={() => setCheckoutPage(false)} route={route} />
  }

  const openMethod = (option) => {
    setSelectedCrypto(option)
    setActiveMethod(option)
    setDepositAmount('')
    setShowModal(true)
  }

  return (
    <div className="ud-layout">
      <Userdashboardheader route={route} />

      <div className="ud-main">
        <DashboardTopbar route={route} title="Deposit" />

        <div className="ud-content">

          {/* Amount modal */}
          {showModal && activeMethod && (
            <div className="ud-modal-overlay">
              <div className="ud-modal">
                <button className="ud-modal-close" onClick={() => setShowModal(false)} aria-label="Close"><MdClose size={16} /></button>
                <div className="udf-modal-coin">
                  <img src={activeMethod.image} alt="" className="udf-coin-img" />
                  <div>
                    <p className="ud-modal-title">Deposit via {activeMethod.method}</p>
                    <p className="ud-modal-sub">Minimum: <strong>${activeMethod.min}</strong></p>
                  </div>
                </div>
                <div className="ud-amount-input-wrap">
                  <span className="ud-amount-prefix">$</span>
                  <input type="number" placeholder="0.00" className="ud-amount-input" autoFocus
                    value={depositAmount} onChange={e => setDepositAmount(e.target.value)} />
                  <span className="ud-amount-suffix">USD</span>
                </div>
                <div className="ud-modal-actions">
                  <button className="ud-btn-ghost" onClick={() => setShowModal(false)}>Cancel</button>
                  <button className="ud-btn-primary" onClick={handleNext}>Continue <FiChevronRight /></button>
                </div>
              </div>
            </div>
          )}

          <PageHero
            icon={<FiArrowDownLeft />}
            eyebrow="Fund account"
            title="Make a deposit"
            description="Choose a cryptocurrency, enter an amount, and send it to the wallet address we give you. Your balance updates once the deposit is confirmed."
          >
            <div className="ud-hero-figure">
              <span>Current balance</span>
              <strong>${Number(balance || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}</strong>
            </div>
          </PageHero>

          <div className="ud-section-header udf-section-row">
            <div>
              <h2>Deposit methods</h2>
              <p>Select a cryptocurrency to continue.</p>
            </div>
            <button className="ud-btn-ghost" onClick={() => navigate('/deposit')}>
              <FiClock /> Deposit history
            </button>
          </div>

          <div className="udf-method-grid">
            {depositOptions.map(option => (
              <button
                key={option.id}
                className={`udf-method-tile${selectedCrypto?.id === option.id ? ' active' : ''}`}
                onClick={() => openMethod(option)}
              >
                <img src={option.image} alt="" className="udf-coin-img" />
                <span className="udf-method-text">
                  <span className="udf-method-name">{option.method}</span>
                  <span className="udf-method-min">Min ${option.min}</span>
                </span>
                <FiChevronRight className="udf-method-arrow" />
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Userdashboardfundaccount
